import {FolderDTO} from '../../api/data-contracts'
import BootstrapTable, {ColumnDescription} from 'react-bootstrap-table-next'
import _ from 'lodash'
import {useDispatch, useSelector} from 'react-redux'
import clsx from 'clsx'
import {getDocumentState, loadDocuments, setSelectedFolder} from '../../redux/documentSlice'
import {KTSVG} from '../../../_metronic/helpers'
import {useMemo, useState} from 'react'
import {defterdar_log} from '../../utils/utilities'
import FoldersSubTable from './FoldersSubTable'
import FolderBadges from './FolderBadges'

function FoldersTable() {
  const dispatch = useDispatch()

  const documentState = useSelector(getDocumentState)

  const columns: ColumnDescription[] = [
    {
      dataField: documentState.selectedFolder?.id?.toString(),
      text: 'Klasörler',
      sort: false,
      headerStyle: {width: '80%'},
      classes: (cell: any, row: FolderDTO, rowIndex: number, colIndex: number) =>
        clsx('fs-6 px-0', {
          'ps-5': !(row.subFolders && row.subFolders.length > 0),
        }),
      formatter: (cell: any, row: FolderDTO, rowIndex: number, colIndex: number) => (
        <>
          {row.subFolders && row.subFolders.length > 0 ? (
            <div className='accordion accordion-icon-toggle' id={`kt_accordion_${rowIndex}`}>
              <div
                className='d-flex ps-5'
                data-bs-toggle='collapse'
                data-bs-target={`#kt_accordion_${rowIndex}_item_1`}
              >
                <div className='d-flex justify-content-between pe-4 w-100'>
                  <div className='d-flex'>
                    <i className='bi bi-folder fs-4 text-gray-900 me-3'></i>
                    {row.name}
                    <span className='accordion-icon'>
                      <KTSVG
                        className='svg-icon svg-icon-4'
                        path='/media/icons/duotune/arrows/arr064.svg'
                      />
                    </span>
                  </div>

                  <FolderBadges folder={row} />
                </div>
              </div>
              <div
                id={`kt_accordion_${rowIndex}_item_1`}
                className='fs-6 collapse  mt-2'
                data-bs-parent={`#kt_accordion_${rowIndex}`}
                style={{maxHeight: '200px', overflowY: 'auto'}}
              >
                <FoldersSubTable folders={row.subFolders} />
              </div>
            </div>
          ) : (
            <div className='d-flex justify-content-between pe-4'>
              <div>
                <i className='bi bi-folder fs-4 text-gray-900 me-3'></i>
                {row.name}
              </div>
              <FolderBadges folder={row} />
            </div>
          )}
        </>
      ),
    },
  ]

  const rowClasses = (row: FolderDTO, rowIndex: number): string => {
    return clsx('border border-gray-200', {
      'table-active': row.id === documentState.selectedFolder?.id,
    })
  }

  return (
    <div className='table-responsive h-100'>
      <>
        <div>
          <BootstrapTable
            keyField='id'
            data={_.orderBy(documentState.folders, (o) => o.name, 'asc') ?? []}
            columns={columns}
            classes='table table-rounded border gy-2 gs-7'
            rowClasses={rowClasses}
            headerClasses='fw-bold fs-6 text-gray-800 border-bottom border-gray-200 bg-primary bg-opacity-50'
            rowStyle={{cursor: 'pointer'}}
            rowEvents={{
              onClick: async (e, row: FolderDTO, rowIndex) => {
                if (row.subFolders && row.subFolders.length > 0) return
                await dispatch(setSelectedFolder(row))
                await dispatch<any>(loadDocuments())
              },
            }}
          />
        </div>
      </>
    </div>
  )
}

export default FoldersTable
